import { getAxiosClient } from 'utils/axios';

import { handleApiError } from './utils';

/**
 * @deprecated 應棄用此種寫法
 */
export const getSeries = async () => {
    const cli = getAxiosClient('GetSeries');
    try {
        const res = await cli.get(`/v1/series`);
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};

export const getSeriesV2 = () => async () => {
    const cli = getAxiosClient('GetSeries');
    try {
        const res = await cli.get(`/v1/series`);
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};

/**
 * @param {string} userId
 * @param {string} seriesId
 */
export const linkSeries = (userId, seriesId) => async () => {
    const cli = getAxiosClient('LinkSeries');
    try {
        const res = await cli.post(`/v1/series/link`, JSON.stringify({ userId, seriesId }));
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};
